"use client";
import {
  useDialogStoreProps
} from "./5NIUVND5.js";
import {
  useStore,
  useStoreProps
} from "./Q3KUZPD7.js";
import {
  useUpdateEffect
} from "./K2XTQB3X.js";

// src/popover/popover-store.ts
import * as Core from "@ariakit/core/popover/popover-store";
function usePopoverStoreProps(store, update, props) {
  useUpdateEffect(update, [props.popover]);
  useStoreProps(store, props, "placement");
  return useDialogStoreProps(store, update, props);
}
function usePopoverStore(props = {}) {
  const [store, update] = useStore(Core.createPopoverStore, props);
  return usePopoverStoreProps(store, update, props);
}

export {
  usePopoverStoreProps,
  usePopoverStore
};
